import { deepEquals } from '@/core/utils/utils';
import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'ListItemCheck',
  props: {
    modelValue: {
      required: true,
    },
    name: {
      required: true,
      type: String,
    },
    inputId: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
    value: {
      required: false,
    },
    last: {
      type: Boolean,
      default: false,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    binary: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  emits: ['update:modelValue','update:value'],
})
export default class ListItemCheck extends Vue {
  modelValue!: any;
  name!: string;
  inputId!: string;
  value!: any;
  last!: boolean;
  label!: string;
  disabled!: boolean;
  binary!: boolean;

  get checked() {
    return this.binary ? this.modelValue : this.modelValue.some((val: any) => deepEquals(val, this.value));
  }

  setValue() {
    if(this.disabled) return;
    let newModelValue;
    if (this.binary) {
      newModelValue = !this.modelValue;
    } else {
      if (this.checked)
        newModelValue = this.modelValue.filter((val: any) => !deepEquals(val, this.value));
      else
        newModelValue = this.modelValue ? [...this.modelValue, this.value] : [this.value];
    }
    this.$emit('update:value', this.value);
    this.$emit('update:modelValue', newModelValue);
  }
}
